import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { customAlert } from "../../CustomAlert/ConfirmDialog";
import { showToastAlert } from "../../helpers/axios_Config";
import { impersonationResetState } from "../../store/Utilites/Impersonation/action";
import {
    clearRoleAccessForUserSwitch,
    getUserDisplayNameForImpersonation,
    impersonationStorageKeys,
    initializeImpersonationFromStorage,
    restoreSessionSnapshot,
    runLoginUserBootstrap,
} from "../Common/ImpersonationFunc";

const ImpersonationBanner = () => {
    const dispatch = useDispatch();

    const {
        isImpersonating,
        originalUser,
        activeUser,
    } = useSelector((state) => state.ImpersonationReducer);

    useEffect(() => {
        initializeImpersonationFromStorage(dispatch);
    }, []);

    if (!isImpersonating) {
        return null;
    }

    const switchBackHandler = async () => {
        const isConfirmed = await customAlert({
            Type: 7,
            Message: `Switch back to ${getUserDisplayNameForImpersonation(originalUser)}?`,
        });

        if (!isConfirmed) {
            return;
        }

        const { originalUserSession, isImpersonating: isImpersonatingKey } = impersonationStorageKeys();
        const snapshot = JSON.parse(localStorage.getItem(originalUserSession) || "null");

        if (!snapshot?.roleId) {
            customAlert({ Type: 4, Message: "Original user session was not found. Please logout and login again." });
            return;
        }

        restoreSessionSnapshot(snapshot);
        localStorage.removeItem(originalUserSession);
        localStorage.removeItem(isImpersonatingKey);

        clearRoleAccessForUserSwitch(dispatch);
        runLoginUserBootstrap(snapshot.roleId, dispatch, { preserveSelectedParty: true });
        dispatch(impersonationResetState());
        showToastAlert(`Switched back to ${getUserDisplayNameForImpersonation(snapshot.roleId)}`, "success");
    };

    return (
        <div className="impersonation-status-line">
            <span>Viewing as {getUserDisplayNameForImpersonation(activeUser)}</span>
            <button
                type="button"
                className="impersonation-switch-back"
                onClick={switchBackHandler}
            >
                Switch back to {getUserDisplayNameForImpersonation(originalUser)}
            </button>
        </div>
    );
};

export default ImpersonationBanner;
